/**
 * A zero width space (x200B) lets the user double click a text element to
 * select it without extending the selection to neighboring elements. You can
 * also use a regular space, but you may want to use a zero width space if you
 * need to precisely match the margins specified in designs.
 */
export default function ZeroWidthSpaceToken() {
  return <>&#x200B;</>
}
